import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { AdminServiceOfferListRepository } from './domain'

import { AdminListCriteria, AdminServiceOfferListItem } from '../../contracts/service-offer'
import { AxiosErrorHandler, SupernovaPagedBody } from '../../foundation'

export class AdminApiServiceOfferList implements AdminServiceOfferListRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (criteria: AdminListCriteria): Promise<SupernovaPagedBody<AdminServiceOfferListItem[]>> => {
    const config: AxiosRequestConfig<AdminListCriteria> = {
      url: '/service-offer/query/admin/service-offer-list/process',
      method: 'post',
      data: criteria,
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedBody<AdminServiceOfferListItem[]>>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
